// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "customer-260422-2/static/css/" + chunkId + "." + {"164":"da92b39f","710":"da92b39f","2280":"5132f0ec","2395":"da92b39f","2473":"5132f0ec","2918":"5132f0ec","2982":"07a465cd","6872":"da92b39f","7010":"5132f0ec"}[chunkId] + ".chunk.css";
};